module.exports = __webpack_public_path__ + "img/9788925565323.f2569d1c.jpg";